import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'grt-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
